
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckoutValuesCard',
  props: {
    destination: { type: String, default: '' },
    prompt: { type: Number, required: true },
    productsValue: { type: Number, required: true },
    freightValue: { type: Number, required: true },
    totalValue: { type: Number, required: true },
  },
  methods: {
    formatCurrency(value: number) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(value || 0);
    },
  },
});
